import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

// モバイル判定を先頭に移動
const mobileQuery = window.matchMedia('(max-width: 768px)');
let isMobile = mobileQuery.matches;

mobileQuery.addListener((e) => {
  isMobile = e.matches;
});

// GSAP の ScrollTrigger プラグインを登録
gsap.registerPlugin(ScrollTrigger);


// Swiper 1
const swiper = new Swiper('.swiper-primary', {
  modules: [Navigation, Autoplay],
  slidesPerView: 'auto',
  centeredSlides: false,
  spaceBetween: 30,
  loop: false, // ループをオフに
  speed: 500, // スライド時のアニメーション速度（ミリ秒）

  // ナビゲーションボタン (クラス名を変更)
  navigation: {
    nextEl: '.swiper-primary-button-next',
    prevEl: '.swiper-primary-button-prev',
  },

  // 自動再生を無効化
  autoplay: false,

  // 手動スワイプを有効化
  allowTouchMove: true,

  // レスポンシブ設定
  breakpoints: {
    320: { slidesPerView: 'auto', spaceBetween: 20 },
    768: { slidesPerView: 'auto', spaceBetween: 30 },
    1024: { slidesPerView: 'auto', spaceBetween: 30 }
  }
});

// Swiper 2
const swiper2 = new Swiper('.swiper-secondary', {
  modules: [Navigation, Autoplay],
  slidesPerView: 'auto',
  centeredSlides: false,
  spaceBetween: 30,
  loop: false, // ループをオフに
  speed: 500, // スライド時のアニメーション速度（ミリ秒）

  // ナビゲーションボタン (クラス名を変更)
  navigation: {
    nextEl: '.swiper-secondary-button-next',
    prevEl: '.swiper-secondary-button-prev',
  },

  // 自動再生を無効化
  autoplay: false,

  // 手動スワイプを有効化
  allowTouchMove: true,

  // レスポンシブ設定
  breakpoints: {
    320: { slidesPerView: 'auto', spaceBetween: 20 },
    768: { slidesPerView: 'auto', spaceBetween: 30 },
    1024: { slidesPerView: 'auto', spaceBetween: 30 }
  }
});

// ページの読み込みが完了したらローディングを非表示
window.addEventListener('load', () => {
  const loading = document.getElementById('loading');
  
  // 少し遅延させてからローディングを非表示
  setTimeout(() => {
    loading.classList.add('is-loaded');
  }, 1000);
});

document.addEventListener('DOMContentLoaded', () => {
  // 製品情報ドロップダウンのアニメーション付きトグル
  const toggle = document.getElementById('products-toggle');
  const dropdown = document.getElementById('dropdown-products');
  if (toggle && dropdown) {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      if (dropdown.classList.contains('hidden')) {
        dropdown.classList.remove('hidden');
        gsap.fromTo(dropdown, { opacity: 0 }, { opacity: 1, duration: 0.5 });
      } else {
        gsap.to(dropdown, { opacity: 0, duration: 0.5, onComplete: () => dropdown.classList.add('hidden') });
      }
    });
  }
  
  // モバイルハンバーガーメニュー（ドロップダウンとアイコン切替）
  const mobileToggle = document.getElementById('mobile-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', (e) => {
      e.preventDefault();
      if (mobileMenu.classList.contains('hidden')) {
        mobileMenu.classList.remove('hidden');
        gsap.fromTo(mobileMenu, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.5 });
        mobileToggle.classList.add('active');
      } else {
        gsap.to(mobileMenu, { opacity: 0, y: -20, duration: 0.5, onComplete: () => {
          mobileMenu.classList.add('hidden');
          mobileToggle.classList.remove('active');
        }});
      }
    });
  }
  
  // モバイルメニューのクローズボタン（アニメーション付き）
  const mobileClose = document.getElementById('mobile-close');
  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener('click', (e) => {
      e.preventDefault();
      gsap.to(mobileMenu, { opacity: 0, duration: 0.5, onComplete: () => mobileMenu.classList.add('hidden') });
    });
  }

  // Scroll-triggered fade-in animation for elements with .scroll-animation class
  const scrollElements = document.querySelectorAll('.is-scroll-animation');
  const observerOptions = { threshold: 0.2 };  // adjust threshold if needed
  const scrollObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  scrollElements.forEach(el => scrollObserver.observe(el));

  // Main Copy Animations
  window.addEventListener('load', () => {
    // Function to check if background images are loaded
    const checkBackgroundImagesLoaded = (elements) => {
      return Promise.all(
        elements.map(element => {
          const rugbyImage = element.querySelector('.rugby-image');
          if (!rugbyImage) return Promise.resolve();
          
          const bgImage = window.getComputedStyle(rugbyImage).backgroundImage;
          if (bgImage && bgImage !== 'none') {
            const imageUrl = bgImage.replace(/url\(['"]?(.*?)['"]?\)/i, '$1');
            return new Promise((resolve) => {
              const img = new Image();
              img.onload = () => resolve();
              img.onerror = () => resolve(); // Proceed even if image fails to load
              img.src = imageUrl;
            });
          }
          return Promise.resolve();
        })
      );
    };

    // メインコピー要素を取得
    const mainCopyElements = ['#main-copy1', '#main-copy2', '#main-copy3'];
    
    // すべての要素にopacity:1を設定
    mainCopyElements.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) {
        gsap.set(element, { opacity: 1 });
      }
    });

    // アニメーション処理
    if (!isMobile) {
      const mainCopyTl = gsap.timeline({ delay: 1 }); // Add delay to sync with loading animation
      
      mainCopyTl.from("#main-copy1 > *", {
        yPercent: 100,
        opacity: 0,
        duration: 1,
        ease: "power4.out"
      })
      .fromTo("#main-copy1",
        { 
          clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",
          opacity: 0
        },
        {
          clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
          opacity: 1,
          duration: 1,
          ease: "power4.inOut"
        },
        "<0.2"
      )
      .fromTo(["#main-copy2", "#main-copy3"],
        { 
          y: 20,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.3,
          ease: "power2.out"
        }
      );
    }
  });

  // Close dropdown-products when clicking outside the menu
  document.addEventListener('click', (e) => {
    // For dropdown-products
    if (dropdown && !dropdown.contains(e.target) && !toggle.contains(e.target)) {
      if (!dropdown.classList.contains('hidden')) {
        gsap.to(dropdown, { 
          opacity: 0, 
          duration: 0.5, 
          onComplete: () => dropdown.classList.add('hidden')
        });
      }
    }
    // Optional: Close mobile-menu when clicking outside of it and the toggle
    if (mobileMenu && !mobileMenu.contains(e.target) && !mobileToggle.contains(e.target)) {
      if (!mobileMenu.classList.contains('hidden')) {
        gsap.to(mobileMenu, { opacity: 0, y: -20, duration: 0.5, onComplete: () => {
          mobileMenu.classList.add('hidden');
          mobileToggle.classList.remove('active');
        }});
      }
    }
  });

  // クリッピングアニメーションを更新
  const clipAnimations = document.querySelectorAll('.clip-animation');
  clipAnimations.forEach((element) => {
    if (isMobile) {
      // モバイル時は直接表示
      gsap.set(element, { 
        opacity: 1,
        y: 0,
        clearProps: "clip-path"
      });
    } else {
      // デスクトップ用の既存アニメーション
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          toggleActions: "play none none none",
        }
      });
  
      tl.from(element.children, {
        yPercent: 100,
        duration: 1,
        ease: "power4.out",
      })
      .fromTo(element,
        { clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)" },
        {
          clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
          duration: 1,
          ease: "power4.inOut",
        },
        "<0.2"
      );
    }
  });

  // FAQ アコーディオンの初期化
  const accordionItems = document.querySelectorAll('.accordion-item');
  
  accordionItems.forEach(item => {
    const checkbox = item.querySelector('input[type="checkbox"]');
    const contentDiv = item.querySelector('.max-h-0');
    const plusIcon = item.querySelector('.accordion-icon.plus');
    const minusIcon = item.querySelector('.accordion-icon.minus');
    
    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        // 開いた時の高さを動的に計算
        const height = contentDiv.scrollHeight;
        contentDiv.style.maxHeight = `${height}px`;
        
        // アイコンの切り替え（開いた状態）
        gsap.to(plusIcon, { opacity: 0, duration: 0.3 });
        gsap.to(minusIcon, { opacity: 1, duration: 0.3 });
      } else {
        contentDiv.style.maxHeight = '0';
        
        // アイコンの切り替え（閉じた状態）
        gsap.to(plusIcon, { opacity: 1, duration: 0.3 });
        gsap.to(minusIcon, { opacity: 0, duration: 0.3 });
      }
    });
  });
});